export default "__VITE_ASSET__D_S252wy__"